// extracted by mini-css-extract-plugin
export default {"mainDiv":"Home_mainDiv__rn+bV","card":"Home_card__fvRpA","links":"Home_links__ZWpiE"};